<template>
  <Body class="page-download" />

  <section class="page-header">
    <div class="wrap">
      <div class="text">
        <h1 class="title">
          {{ $t('다운로드') }}
        </h1>
        <div class="desc" v-html="$t('가족이웃지인이생각날때마음을담아문자와함께보내보세요')" />
      </div>
    </div>
  </section>

  <section class="section-list">
    <div v-if="downloadDocs && downloadDocs.length > 0" class="wrap">
      <ul class="lists list-download">
        <li v-for="doc in downloadDocs" :key="doc.id" class="list-item">
          <a :href="`/download/${doc.id}`" class="list-link">
            <div class="thum default">
              <div class="thum-img" :style="{ backgroundImage: `url(${doc.thumbnail})` }" />
            </div>
            <div class="info">
              <div class="post-title">{{ doc.title }}</div>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div v-else class="no-data wrap">
      {{ $t('등록된글이없어요') }}
    </div>
  </section>
</template>

<script lang="ts" setup>
const { $t } = useNuxtApp()

useHead({
  title: `${$t('다운로드')} - ${$t('어머니사랑과평화의날캠페인')}`,
  link: [{ rel: 'stylesheet', href: `/css/download.css?${useBuildTime()}` }],
})

const { fetchDownloadDocs } = useDownloadDoc()

const { data: downloadDocs } = await fetchDownloadDocs()
</script>
